<template>
    <div class="game-info-switch-bar">
        <div v-if="type === 'normal'" v-for="(item, index) in barData" :key="index" @click="changeTab(item, index)"
            :class="[`switch-bar-cell${index}`, { isActive: currentIndex === index }]" class="switch-bar-cell">
            <p>{{ item.title }}</p>
        </div>
        <div v-if="type === 'pullDown'" class="switch-bar-pull-down">
            <div class="switch-bar-title">
                <p>{{ currentTitle }}</p>
            </div>
            <div class="switch-bar-select-area">
                <p class="switch-bar-select-title">
                    選擇等級
                </p>
                <div class="switch-bar-select" @click="showMenu()" v-clickOutSide="hidePullDown">
                    <div class="pull-down-arrow" :class="{ active: showDropDown }">
                    </div>
                </div>
                <div class="pull-down-content" v-show="showDropDown">
                    <div v-for="(item, index) in barData" :key="index" @click="changeTab(item, index, true)"
                        class="pull-down-cell" :class="{ active: currentIndex === index }">
                        <p>{{ item.title }}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import clickOutSide from '../../directive/clickOutSide'
export default {
    props: {
        barData: {
            type: Array,
            default: () => []
        },
        type: {
            type: String, // normal,pullDown
            default: 'normal'
        }
    },
    directives: {
        clickOutSide
    },
    data() {
        return {
            currentIndex: 0,
            showDropDown: false
        }
    },
    computed: {
        currentTitle() {
            let data = this.barData[this.currentIndex]
            if (data && data.title) {
                return data.title
            } else {
                return '--'
            }
        }
    },
    methods: {
        changeTab(item, index, isPullDown = false) {
            if (isPullDown) {
                this.showDropDown = false
            }
            this.currentIndex = index
            this.$emit('changeTab', item.cb)
        },
        showMenu() {
            this.showDropDown = !this.showDropDown
        },
        hidePullDown() {
            this.showDropDown = false
        }
    }
}
</script>

<style lang="scss" scoped>
.game-info-switch-bar {
    height: .48rem;
    background-color: #3d4047;
    display: flex;
    align-items: center;
    justify-content: center;

    .switch-bar-cell {
        flex: 1;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: all .5s;

        &.isActive {
            background-color: #dd585c;

            p {
                color: white;
            }
        }

        p {
            color: #d9d9d9;
            font-size: .24rem;
        }
    }

    .switch-bar-pull-down {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;

        .switch-bar-title {
            p {
                font-size: .26rem;
                color: white;
                font-weight: bold;
            }
        }

        .switch-bar-select-area {
            position: absolute;
            right: .3rem;
            display: flex;
            align-items: center;
            user-select: none;
            cursor: pointer;

            .switch-bar-select-title {
                font-size: .2rem;
                color: #d4d4d4;
                font-weight: bold;
                margin-right: .13rem;
            }

            .switch-bar-select {
                width: .36rem;
                height: .36rem;
                background: #f2f2f4;
                display: flex;
                align-items: center;
                justify-content: center;
                position: relative;

                .pull-down-arrow {
                    width: 0;
                    height: 0;
                    position: relative;
                    transition: all .5s;

                    &.active {
                        transform: rotate(180deg);
                    }
                }

                .pull-down-arrow::after {
                    content: '';
                    position: absolute;
                    top: 0;
                    left: 50%;
                    transform: translate(-50%, -70%) rotate(45deg);
                    width: .16rem;
                    height: .16rem;
                    border-right: .04rem solid #3b3f47;
                    border-bottom: .04rem solid #3b3f47;
                }
            }
        }

        .pull-down-content {
            position: absolute;
            box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
            top: 0.5rem;
            right: -0.2rem;
            width: 1.45rem;
            background-color: white;
            padding: .1rem 0;
            transition: all .5s;

            .pull-down-cell {
                height: .32rem;
                display: flex;
                align-items: center;
                justify-content: center;
                margin-bottom: .05rem;

                p {
                    font-size: .2rem;
                    color: #3b3f47;
                    text-align: center;
                    line-height: .32rem;
                    font-weight: bold;
                }

                &.active {
                    background-color: #ebeff3;
                }
            }
        }

        .pull-down-content::before {
            //向上箭头
            content: '';
            position: absolute;
            top: -.1rem;
            right: .3rem;
            width: 0;
            height: 0;
            border-left: .1rem solid transparent;
            border-right: .1rem solid transparent;
            border-bottom: .1rem solid white;

        }

    }
}
</style>